import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { filterRequest } from "../../utilities/apiManager";
import axiosInstance from "../../utilities/axiosInstance";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getSalaries = createAsyncThunk(
  "salaries/getSalaries",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const filter = filterRequest(args.filter);
      const { data } = await axiosInstance.get(
        `/salaries?page=${page}&size=${size}&query=${query}${filter}`
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createSalary = createAsyncThunk(
  "salaries/createSalary",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(
        `/salaries`,
        args
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateSalary = createAsyncThunk(
  "salaries/updateSalary",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.put(
        `/salaries/${args._id}`,
        args
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const deleteSalary = createAsyncThunk(
  "salaries/deleteSalary",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.delete(
        `/salaries/${args._id}`
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const salariesSlice = createSlice({
  name: "salaries",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getSalaries.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(getSalaries.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload.data;
        state.itemsCount = payload.itemsCount;
        state.pages = payload.pages;
      })
      .addCase(getSalaries.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(createSalary.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createSalary.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data.push(payload.data);
        state.itemsCount++;
        state.error = null;
      })
      .addCase(createSalary.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateSalary.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateSalary.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        const indexAt = state.data.findIndex(el => el._id === payload.data._id);
        state.data[indexAt] = payload.data;
        state.error = null;
      })
      .addCase(updateSalary.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(deleteSalary.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteSalary.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = state.data.filter(el => el._id !== payload.data._id);
        state.error = null;
      })
      .addCase(deleteSalary.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default salariesSlice.reducer;